
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.674 8.022a5.348 5.348 0 015.348-5.348c1.683 0 3.161.778 4.133 2.001l-1.123-.003a.669.669 0 00-.004 1.337l2.302.007a.666.666 0 00.078 0h.295a.668.668 0 00.67-.668V2.674a.669.669 0 10-1.337 0v.97a6.572 6.572 0 00-5.014-2.307 6.685 6.685 0 100 13.37c2.631 0 4.856-1.519 5.947-3.713a.669.669 0 00-1.197-.595c-.879 1.768-2.656 2.972-4.75 2.972a5.348 5.348 0 01-5.348-5.349z","fill":"currentColor"}})])
          )
        }
      }
    